/** Client-side helpers for server-verified integrity footprints. */

export function isIntegrityTampered(item) {
  if (!item || typeof item !== "object") return false;
  if (item.integrityStatus === "tampered") return true;
  if (item.integrityOk === false && item.integrityStatus !== "legacy") {
    return true;
  }
  return false;
}

export function anyIntegrityTampered(items) {
  if (!Array.isArray(items)) return false;
  return items.some(isIntegrityTampered);
}
